import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FameStage from 'components/molecules/Fame/Stage';
import { actionCreators, getCoach, getLevel, getNextLevelThreshold, getPoints, getProgressData } from 'store/mySuccess';
import { getCurrentViewID } from 'store/view';

const mapStateToProps = (state: any) => ({
	currentViewID: getCurrentViewID(state),
	points: getPoints(state),
	nextLevelThreshold: getNextLevelThreshold(state),
	coach: getCoach(state),
	level: getLevel(state),
	progress: getProgressData(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ ...actionCreators }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FameStage as any);
